import { render } from "./CookieBanner.vue?vue&type=template&id=3d5d81da&scoped=true"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"

import "./CookieBanner.vue?vue&type=style&index=0&id=3d5d81da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5d81da"]])

export default __exports__